App.filter('percentageOfBenefit', function () {
    return function (list) {
        if (!angular.isDefined(list)) return false;
        if (!angular.isArray(list)) return false;
        if (!list.length) return true;

        var max = 100;

        angular.forEach(list, function (currentAssured) {
            max -= currentAssured.percent || 0;
        });

        return max === 0;
    }
});
